import { useEffect, useState } from "react";

import Layout from "../components/layout/Layout.component";

import { BiSolidPlaneLand, BiSolidPlaneTakeOff } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import { GrLocation } from "react-icons/gr";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from "../components/utils/Skeleton.component";
import { usePacotes } from "../services";
import SlugViagemDetails from "../styles/pages/SlugViagemDetails";
import { Breadcrumbs, Divider, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

function SlugViagem() {
  const [path, setPath] = useState<string>();
  const { selectedData, getPacote, loading } = usePacotes();

  useEffect(() => {
    window.scrollTo(0, 0);
    function getPath() {
      const pathname = window.location.pathname.slice(9);

      setPath(
        decodeURIComponent(
          pathname
            .split("-")
            .map((word) =>
              word
                .split("")
                .map((char, index) => (index === 0 ? char.toUpperCase() : char))
                .join("")
            )
            .join(" ")
        )
      );
    }

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const id = params.get("id");

    if (id) {
      getPacote(id);
    }

    getPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <SlugViagemDetails>
        <div className="content">
          <Breadcrumbs>
            <Link
              underline="hover"
              href="/"
              sx={{ display: "flex", alignItems: "center", color: "black" }}
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Home
            </Link>
            <Link
              underline="hover"
              href="/viagens"
              sx={{ display: "flex", alignItems: "center", color: "black" }}
            >
              Viagens
            </Link>
            <Typography sx={{ color: "text.primary" }}>{path}</Typography>
          </Breadcrumbs>
          <Typography variant="h4" mt={4}>
            {path}
          </Typography>
          <div className="content-page">
            <div className="header">
              <div className="carousel">
                {loading ? (
                  <Skeleton height="400px" />
                ) : (
                  <Swiper
                    pagination={true}
                    navigation={true}
                    style={{
                      "--swiper-navigation-color": "#fff",
                      "--swiper-pagination-color": "#fff",
                    }}
                    modules={[Navigation, Pagination]}
                  >
                    {selectedData?.imagesUrl.map((item, key) => (
                      <SwiperSlide>
                        <img src={item} key={key} alt="Croulse-child" />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
              {loading ? (
                <Skeleton height="400px" width="30%" />
              ) : (
                <div className="card-info">
                  <Typography variant="h6">Informações</Typography>
                  <div className="info-viagem">
                    <p className="partida">
                      <div className="icon">
                        <BiSolidPlaneTakeOff />
                      </div>
                      {handleDate(selectedData?.data_partida || "")}
                    </p>
                    <p className="retorno">
                      <div className="icon">
                        <BiSolidPlaneLand />
                      </div>
                      {handleDate(selectedData?.data_retorno || "")}
                    </p>
                  </div>
                  <div className="location">
                    <GrLocation />
                    {selectedData?.local}
                  </div>
                  <Divider />
                  <div className="preco">
                    <p className="info">A partir de</p>
                    <p
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <span>R$</span>
                      <p className="currency">
                        {selectedData?.preco.slice(0, -3)}
                      </p>
                    </p>
                  </div>
                  <a
                    className="button"
                    href="https://api.whatsapp.com/send/?phone=45998494362"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaWhatsapp /> Entrar em contato
                  </a>
                </div>
              )}
            </div>
            <Divider />
            {loading ? (
              <Skeleton width="100%" height="300px" />
            ) : (
              <div className="desc">
                <Typography variant="h6">Descrição</Typography>
                <div
                  className="content-desc"
                  dangerouslySetInnerHTML={{
                    __html: selectedData?.descricao || "",
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </SlugViagemDetails>
    </Layout>
  );
}

const handleDate = (inicial: string) => {
  const monthNames = [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ];

  const date = new Date(inicial);

  return `${date.getDate()} de ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()}`;
};

export default SlugViagem;
